import * as React from 'react'

import { User as TUser }                                  from '../../api'
import withDialogControls, { InjectedDialogControlProps } from '../hocs/withDialogControls'
import { UserCard, UserInfoPopup }                        from '../molecules'

interface UserProps {
  user: TUser
  onClick?: () => void
}

const User = ({
  user,
  close,
  open,
  isOpen,
}: InjectedDialogControlProps & UserProps) =>
  user
    ?
    (
      <>
        <UserCard
          user={user}
          onClick={open}
        />
        {user.account.active && (
          <UserInfoPopup
            user={user}
            close={close}
            isOpen={isOpen}
          />
        )}
      </>
    )
    : null

export default withDialogControls(User)



// WEBPACK FOOTER //
// ./src/components/organisms/User.tsx